import * as React from 'react';

type TbodyProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLTableSectionElement>, HTMLTableSectionElement>;

export const Tbody: React.FC<TbodyProps> = ({ children, ...props }) => {
	return <tbody className="table__body" {...props}>{children}</tbody>;
};
